import config from 'src/config';
import { loadStripe } from '@stripe/stripe-js';

let stripePromise;
let stripeKey = '';
const stripeOptions = {
  developerTools: {
    assistant: {
      enabled: false
    }
  }
};

export const getStripePublishableKey = () => {
  return config.get('stripe').publishableKey;
};

export const getStripePromise = () => {
  const publishableKey = getStripePublishableKey();

  if (!stripePromise || stripeKey !== publishableKey) {
    stripeKey = publishableKey;
    const nextPromise = loadStripe(publishableKey, stripeOptions).catch((error) => {
      if (stripePromise === nextPromise) {
        stripePromise = null;
        stripeKey = '';
      }

      throw error;
    });

    stripePromise = nextPromise;
  }

  return stripePromise;
};